var UserPhoto = /** @class */ (function () {
    function UserPhoto() {
        this.id = 0;
        this.key = '';
        this.file_name = '';
        this.url = '';
        this.path = '';
        this.status = 'create';
        this.created_at = '';
    }
    return UserPhoto;
}());
export { UserPhoto };
